export default __webpack_public_path__ + "static/tomorrowland-2-84fe52677f1e707598fb3902f71a0a11.jpg";